import { useLDFlags } from './LD/useLDFlags';

export default function useQuizId() {
  const { 'quiz-router': quizId = '1' } = useLDFlags();

  return quizId;
}
